import React from "react";
import { motion } from "framer-motion";
import { useApp } from "@/context/AppProvider";
import { Reveal } from "@/components/motion";
import { EditableText, ListControls, AddButton } from "@/components/editable";
import { TEMPLATES } from "@/content";

export const Experience = () => {
  const { tr, ed, editMode, moveItem, removeItem, addItem } = useApp();
  const path = ["experience", "items"];
  const items = tr.experience.items;

  return (
    <section id="experience" data-testid="experience" className="relative py-24 md:py-32 lg:py-40" style={{ backgroundColor: "var(--sand)" }}>
      <div className="container-lux">
        <Reveal className="max-w-2xl mb-16">
          <EditableText as="p" path={["experience", "eyebrow"]} value={tr.experience.eyebrow} className="eyebrow mb-4 inline-block" />
          <EditableText as="h2" multiline path={["experience", "title"]} value={tr.experience.title} className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.1] block" style={{ color: "var(--ink)" }} />
        </Reveal>

        <div className="relative">
          <div className="absolute top-0 bottom-0 start-0 w-[1px]" style={{ backgroundColor: "rgba(19,19,19,0.12)" }} />
          <div className="space-y-14">
            {items.map((item, i) => (
              <Reveal key={i} delay={i * 0.06}>
                <div className={`relative ps-8 md:ps-14 group ${editMode ? "editing-outline" : ""}`}>
                  <motion.span className="absolute start-[-5px] top-2 w-[11px] h-[11px] rounded-full" style={{ backgroundColor: "var(--gold)" }} whileInView={{ scale: [0, 1.4, 1] }} transition={{ duration: 0.6 }} viewport={{ once: true }} />
                  {editMode && (
                    <ListControls
                      className="absolute -top-3 end-0"
                      onUp={() => moveItem(path, i, -1)}
                      onDown={() => moveItem(path, i, 1)}
                      onDelete={() => removeItem(path, i)}
                      canUp={i > 0}
                      canDown={i < items.length - 1}
                      testid={`experience-controls-${i}`}
                    />
                  )}
                  <div className="grid md:grid-cols-12 gap-2 md:gap-8 items-baseline">
                    <EditableText as="p" path={[...path, i, "period"]} value={item.period} className="md:col-span-3 font-body text-sm tracking-wide block" style={{ color: "var(--gold)" }} />
                    <div className="md:col-span-9">
                      <EditableText as="h3" path={[...path, i, "role"]} value={item.role} className="font-display text-2xl md:text-3xl mb-1 block" style={{ color: "var(--ink)" }} />
                      <EditableText as="p" path={[...path, i, "company"]} value={item.company} className="font-body text-base font-medium mb-3 block" style={{ color: "var(--ink)" }} />
                      <EditableText as="p" multiline path={[...path, i, "desc"]} value={item.desc} className="font-body text-base leading-relaxed max-w-2xl block" style={{ color: "var(--ink-soft)" }} />
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
        <div className="mt-12 ps-8 md:ps-14">
          <AddButton onClick={() => addItem(path, TEMPLATES.experienceItem.en, TEMPLATES.experienceItem.ar)} label={ed.addItem} testid="add-experience" />
        </div>
      </div>
    </section>
  );
};
